import Repository from './repository'

export default {
  requestForOtp({
    verificationMethod,
    email,
    encryptedBookingNo,
  }: {
    verificationMethod: 'sms' | 'email'
    email: string
    encryptedBookingNo: string
  }) {
    return Repository.post(
      `/v2/bookings/${encodeURIComponent(encryptedBookingNo)}/digital_keys/member_verifications`,
      { verificationMethod, email }
    )
  },

  verifyOtp({
    email,
    encryptedBookingNo,
    otpCode,
  }: {
    email: string
    encryptedBookingNo: string
    otpCode: string
  }) {
    // Skip the global error UI (Verify shows its own messages) and the top progress
    // bar (the Verify button shows its own inline spinner).
    return Repository.put(
      `/v2/bookings/${encodeURIComponent(encryptedBookingNo)}/digital_keys/member_verifications`,
      { email, otpCode },
      { skipGlobalErrorHandling: true, skipProgressBar: true }
    )
  },

  requestForWalletCredentials({
    email,
    encryptedBookingNo,
    walletType,
  }: {
    email: string
    encryptedBookingNo: string
    walletType: 'apple' | 'google'
  }) {
    return Repository.post(
      `/v2/bookings/${encodeURIComponent(encryptedBookingNo)}/digital_keys`,
      { walletType, email }
    )
  },
}
